// extracted by mini-css-extract-plugin
export default {"footerContent":"Footer_footerContent__GLsTv"};